import axios from "axios";

// const apiUrl = 'http://54.164.22.169:5004/webhooks/custom/webhook/';
const apiUrl = 'https://rasasitsvc.livegage.ai/webhooks/custom/webhook';

export const getChatResponse= async (params:any) => {
    
    return await axios.post(`${apiUrl}`, params);
}

const chatHistoryUrl = 'https://rasasit.livegage.ai/history/retrieve';

export const getChatHistoryResponse= async (params:any) => {


    
    
    return await axios.post(`${chatHistoryUrl}`, params);
}

